import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '~/styling';

export const buttonVariants = cva(
  ['transition', 'ease-in-out', 'delay-75', 'text-center', 'inline-block'],
  {
    variants: {
      intent: {
        primary: [
          `hover:bg-primary-1-40 disabled:bg-neutral-2-20 disabled:text-neutral-2-40 bg-secondary-1 text-primary-2-10 rounded-full px-6 py-4 text-base leading-4 font-medium tracking-wide uppercase after:content-['_⟶'] disabled:border-0 disabled:opacity-50`,
        ],
        secondary: [
          'border-primary-2-80 text-primary-2-80 hover:bg-secondary-1 hover:text-primary-2-10 w-max rounded-full border px-3 py-4',
        ],
        tertiary: [
          'bg-primary-2-10 text-primary-2-80 disabled:bg-neutral-2 disabled:text-neutral-1 rounded-md px-1.5 py-1.5 text-base leading-5 tracking-tight disabled:border-0',
        ],
        filter: [
          'border-primary-2-80 text-primary-2-80 ui-selected:bg-secondary-1 ui-selected:text-neutral-1 rounded-full border px-4 py-2 text-xs leading-3 font-semibold tracking-wide uppercase',
        ],
      },
    },

    defaultVariants: {
      intent: 'primary',
      mode: 'enabled',
    },
  }
);
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: VariantProps<typeof buttonVariants>['intent'];
};

export default function Button({ variant, className, children, ...props }: ButtonProps) {
  return (
    <button className={cn(buttonVariants({ intent: variant }), className)} {...props}>
      {children}
    </button>
  );
}
